import { Component, h, Prop, State, Listen } from '@stencil/core';
import { _BREAKPOINTS_ } from 'utils';

@Component({
    tag: 'kdx-article-detail-hero',
    styleUrl: 'kdx-article-detail-hero.scss'
})
export class KdxArticleDetailHero {
    
    @Prop() backBtnHref: string;
    @Prop() backBtnText: string;
    @Prop() backBtnAlt: string; 
    @Prop() imgSrc: string;
    @Prop() imgSrcMobile: string;
    @Prop() imgAlt: string;
    @Prop() imgBg: string;
    
    @State() bg: string; 

    @Listen('resize', {target: "window"})
    resizeHandler() {
        this.setBG();
        this.setImgBG();
    }

    componentWillLoad() {
        this.setBG();
        this.setImgBG();
    }

    setBG() {
        this.bg = (!this.imgSrcMobile || window.innerWidth >= _BREAKPOINTS_['md']) ? this.imgSrc : this.imgSrcMobile;        
    }

    setImgBG() {
        this.imgBg = 'background: url("' + this.imgSrc + '");  ';        
    }

    render() {
        return (
            <section class="kdx-article-detail-hero" aria-label="article detail hero">
                <div class="container-fluid">
                    <div class="row">

                        <div class="col-md-6">
                            <a href={this.backBtnHref} class="back-btn desktop" aria-label={this.backBtnAlt}>
                                <kdx-icon icon="chevron-left"></kdx-icon>
                                {this.backBtnText}
                            </a>

                            <slot />
                        </div>
                        <div class="col-md-6">
                            <a href={this.backBtnHref} class="back-btn mobile" aria-label={this.backBtnAlt}>
                                <kdx-icon icon="chevron-left"></kdx-icon>
                                {this.backBtnText}
                            </a>
                            {(this.bg) && (
                                <div class="photo" role="image" style={{ background: `url(${this.imgSrc}) no-repeat center/contain`}} aria-describedby={this.imgAlt} title={this.imgAlt} >
                                </div>
                            )}
                        </div>                
                    </div>
                </div>
            </section>
        );
    }
}
